import { formatTakeRate } from '~utils/formatters';
import { Props } from './types';
import * as Styled from './styled';

const LABEL_ID = 'take-authorization-label';

function TakeAuthorization({ takeRate, takeTerms }: Props) {
  return (
    <Styled.Checkbox
      name="takeAuthorization"
      markWhenClickOnLabel={false}
      aria-labelledby={LABEL_ID}
      label={
        <Styled.Label id={LABEL_ID}>
          Estou ciente que será cobrada uma taxa de{' '}
          {takeRate.max_amount !== undefined && 'até '}
          {formatTakeRate(takeRate)}{' '}
          {takeRate.type === 'FIXED'
            ? 'em cada pagamento de frete para empresas parceiras.'
            : 'sobre o valor dos pagamentos de fretes para empresas parceiras.'}{' '}
          <Styled.Link
            href={takeTerms.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Termos e condições da taxa de intermediação
          </Styled.Link>
          .
        </Styled.Label>
      }
    />
  );
}

export default TakeAuthorization;
